import Cookie from 'js-cookie';
import uuid from 'uuid/v4';
import has from 'lodash/has';
import axios from 'axios';
import {removeNulls} from '@/utils/helpers';

export default {
    async pushEvent({state, dispatch}, obj) {
        if (process.server) {
            return;
        }

        const bots = /bot|googlebot|crawler|spider|robot|crawling/i;
        if (bots.test(navigator.userAgent)) {
            return;
        }

        await Promise.all([
            dispatch('saveViewPortSize'),
            dispatch('saveDeviceResolution'),
            dispatch('saveDomainSession'),
            dispatch('saveCurrentPage'),
            dispatch('saveSeekerData'),
            dispatch('saveQueryString'),
        ]);

        // Clear all empty and null index
        const data = removeNulls(Object.assign(JSON.parse(JSON.stringify(state)), obj));
        const url = 'https://api-gateway.careerone.com.au/logs/events';
        const instance = axios.create();

        delete instance.defaults.headers.common['Authorization'];
        delete instance.defaults.headers.common['job-buckets'];
        delete instance.defaults.headers.common['platform-code'];
        delete instance.defaults.headers.common['seeker-buckets'];
        delete instance.defaults.headers.common['site-code'];

        return instance.post(url, {Data: data}, {headers: {c1key: 'HoCBXldx1l9ryZzfob3uo78MQQrTtOnQ2dyqDaYg'}});
    },

    saveViewPortSize({commit}) {
        if (typeof window === 'undefined') {
            return false;
        }

        const viewport = {
            width: window.innerWidth,
            height: window.innerHeight,
        };

        commit('SET', {key: 'viewport_size', value: viewport});
    },

    saveDeviceResolution({commit}) {
        if (typeof window === 'undefined') {
            return false;
        }

        const resolution = {
            width: window.screen.availWidth,
            height: window.screen.availHeight,
        };

        commit('SET', {key: 'device_resolution', value: resolution});
    },

    saveDomainSession({commit}) {
        const cookieName = '_C1_domain_session_id';
        const currentCookie = Cookie.get(cookieName);

        if (!currentCookie) {
            Cookie.set(cookieName, uuid(), {expires: 365 * 10});
        }


        commit('SET', {key: 'site', value: window?.afConfig?.site_code});
        commit('SET', {key: 'platform_code', value: window?.afConfig?.platform_code});
        commit('SET', {key: 'domain_session_id', value: Cookie.get(cookieName)});
    },

    saveCurrentPage({commit}) {
        if (typeof window === 'undefined') {
            return false;
        }

        commit('SET', {key: 'current_page_url', value: window.location.pathname});
    },

    saveSeekerData({commit, rootState}) {
        if (has(rootState, 'me.user.id')) {
            commit('SET', {key: 'seeker_id', value: rootState.me.user.id});
        }

        if (has(rootState, 'me.user.email_hash')) {
            commit('SET', {key: 'seeker_hash', value: rootState.me.user.email_hash});
        }
    },

    saveQueryString({commit}) {
        if (typeof window === 'undefined') {
            return false;
        }

        const search = window.location.search;
        const objURL = {};
        search.replace(
            new RegExp('([^?=&]+)(=([^&]*))?', 'g'),
            function($0, $1, $2, $3) {
                objURL[$1] = $3;
            },
        );

        if (objURL.page_referral_element) {
            commit('SET', {key: 'page_referral_element', value: objURL.page_referral_element});
        }

        if (objURL.utm_source || objURL.source) {
            if (!objURL.utm_source) {
                objURL.utm_source = objURL.source;
            }

            Cookie.set('utm', {
                source: objURL.utm_source,
                medium: objURL.utm_medium,
                campaign: objURL.utm_campaign,
                content: objURL.utm_content,
                term: objURL.utm_term,
            }, {expires: 300});

            commit('SET', {
                key: 'utm',
                value: {
                    source: objURL.utm_source,
                    src: objURL.src,
                    medium: objURL.utm_medium,
                    campaign: objURL.utm_campaign,
                    content: objURL.utm_content,
                    term: objURL.utm_term,
                },
            });
        }

        if (objURL.step) {
            commit('SET', {key: 'step', value: objURL.step});
        }
    },
};
